export default interface IDate {
  today: string,
  start: string,
  end: string,
};

export interface ISplitTime {
  hours: number,
  minutes: number
}
